module.exports = __webpack_public_path__ + "img/Prezencenew2.7865879d.png";